import React, { Component } from "react";
import { Button, FormGroup, Label, Input, Table, Row, Col } from "reactstrap";
import "./AddEditSubsidiaries.css";
import { Typeahead } from "react-bootstrap-typeahead";
import _ from "lodash";
import swal from "sweetalert";
import AddEditSubsidiariesService from "../../services/AddEditSubsidiariesService";
import Validation from "../../services/Validation";
import { messages } from "../../constants/constant.message";
import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";
import TextareaAutosize from "react-autosize-textarea";
const {
  INVALID_SUBSIDIARIES_NAME,
  INVALID_ADDRESS,
  INVALID_STATE,
  INVALID_CITY,
  INVALID_SAP_ID,
} = messages.ADD_EDIT_SUBSIDIARIES;
const { INVALID_GST, INVALID_PAN } = messages.PROFILE;
class AddEditSubsidiaries extends Component {
  stateData = [];
  cityData = [];

  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    this.state = {
      controls:
        _.cloneDeep(
          props.addEditSubsidiaries[props.editSubsidiariesIndex].controls
        ) || {},
      isValidForm:
        props.addEditSubsidiaries && props.addEditSubsidiaries.isValidForm,
      editSubsidiariesIndex: props.editSubsidiariesIndex,
      isAddSubsidiaries: props.isAddSubsidiaries,
      from: props.from,
      isDisplayDetail: false,
    };
    this.getState(); // get vehicle type data
  }
  onCloseSidebar = () => {
    this.props.onCloseSidebar({
      isAddSubsidiaries: this.state.isAddSubsidiaries,
      index: this.props.editSubsidiariesIndex,
    });
  };
  setValue = () => {
    window.scrollTo(0, 0);
    //this.typeaheadState.getInstance().clear();
    // this.typeaheadCity.getInstance().clear();
    this.selectedState = this.props.addEditSubsidiaries[
      this.props.editSubsidiariesIndex
    ].controls.state.value;
    this.selectedCity = this.props.addEditSubsidiaries[
      this.props.editSubsidiariesIndex
    ].controls.city.value;
    this.setState((prevState) => {
      return {
        ...prevState,
        controls:
          _.cloneDeep(
            this.props.addEditSubsidiaries[this.props.editSubsidiariesIndex]
              .controls
          ) || {},
        isValidForm:
          this.props.addEditSubsidiaries &&
          this.props.addEditSubsidiaries.isValidForm,
        editSubsidiariesIndex: this.props.editSubsidiariesIndex,
        isAddSubsidiaries: this.props.isAddSubsidiaries,
        isLoading: false,
        from: this.props.from,
      };
    });
  };
  setEditData = (index, isDisplayDetail = false) => {
    window.scrollTo(0, 0);
    let selectedState = [];
    if (
      typeof this.props.addEditSubsidiaries[index].controls.state.value ===
      "string"
    ) {
      selectedState = this.props.addEditSubsidiaries[index].controls.state.value
        ? _.filter(
          this.stateData,
          function (o) {
            return (
              this.props.addEditSubsidiaries[
                index
              ].controls.state.value.toLowerCase() === o.name.toLowerCase()
            );
          }.bind(this)
        )
        : [];
    } else if (
      typeof this.props.addEditSubsidiaries[index].controls.state.value ===
      "object"
    ) {
      selectedState.push(
        this.props.addEditSubsidiaries[index].controls.state.value
      );
    }
    if (selectedState.length > 0) {
      this.selectedState = selectedState[0];
      this.props.addEditSubsidiaries[index].controls.state.value =
        selectedState[0];
    }
    let selectedCity = [];
    if (
      typeof this.props.addEditSubsidiaries[index].controls.city.value ===
      "string"
    ) {
      selectedCity = _.filter(
        this.cityData,
        function (o) {
          return (
            this.props.addEditSubsidiaries[
              index
            ].controls.city.value.toLowerCase() === o.name.toLowerCase()
          );
        }.bind(this)
      );
    } else if (
      typeof this.props.addEditSubsidiaries[index].controls.city.value ===
      "object"
    ) {
      selectedCity.push(
        this.props.addEditSubsidiaries[index].controls.city.value
      );
    }
    if (selectedCity.length > 0) {
      this.selectedCity = selectedCity[0];
    }
    this.setState((prevState) => {
      return {
        ...prevState,
        controls:
          (this.props.addEditSubsidiaries &&
            this.props.addEditSubsidiaries[index].controls) ||
          {},
        isValidForm:
          this.props.addEditSubsidiaries &&
          this.props.addEditSubsidiaries.isValidForm,
        editSubsidiariesIndex: index,
        isAddSubsidiaries: false,
        from: this.props.from,
        isDisplayDetail: isDisplayDetail ? isDisplayDetail : false,
      };
    });
    setTimeout(() => {
      this.getCity();
    }, 1);
  };

  removeSubsidiaries = (id) => {
    window.scrollTo(0, 0);
    this.props.removeSubsidiaries(id);
  };
  async getState() {
    try {
      const { data } = await AddEditSubsidiariesService.getState();
      if (data) {
        this.stateData = data.data;

        const ownState = _.remove(this.stateData, { is_own_state: true });

        if (ownState.length) {
          this.stateData.unshift(ownState[0]);
        }

        this.setState((prevState) => {
          return { ...prevState };
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  cityClick(cityData) {
    this.selectedCity = cityData;
    const { controls } = this.state;
    controls.city.value = cityData;
    if (controls.city.value) {
      controls.city.showErrorMsg = false;
    }
    this.setState({ controls });
    // this.props.updateState({ visibleArea: 'vehicleRegistrationNumber', vehicleDetails: { controls, isValidForm } });
  }

  async getCity() {
    try {
      const { controls } = this.state;
      this.setState((prevState) => {
        return {
          ...prevState,
          isLoading: true,
        };
      });
      const { data } = await AddEditSubsidiariesService.getCity(
        controls.state.value.state_id
      );
      if (data) {
        this.setState((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
        this.cityData = data.data;
        if (!controls.city.value.city_id && controls.city.value) {
          let selectedCity = _.filter(
            this.cityData,
            function (o) {
              return controls.city.value.toLowerCase() === o.name.toLowerCase();
            }.bind(this)
          );
          if (selectedCity.length > 0) {
            this.selectedCity = selectedCity[0];
            controls.city.value = selectedCity[0];
          }
        }
        const ownCity = _.remove(this.cityData, { is_own_city: true });
        if (ownCity.length) {
          this.cityData.unshift(ownCity[0]);
        }

        // this.setState((prevState) => {
        //   return {
        //     ...prevState, controls: this.props.addEditSubsidiaries && this.props.addEditSubsidiaries[index].controls || {},
        //     isValidForm: this.props.addEditSubsidiaries && this.props.addEditSubsidiaries.isValidForm,
        //     editSubsidiariesIndex: index,
        //     isAddSubsidiaries: false
        //   };
        // });
        this.setState((prevState) => {
          return { controls };
        });
      }
    } catch (error) {
      this.setState((prevState) => {
        return {
          ...prevState,
          isLoading: false,
        };
      });
      console.log(error);
    }
  }

  stateClick(state) {
    this.selectedState = state;
    const { controls } = this.state;
    controls.state.value = state;
    if (controls.state.value) {
      controls.state.showErrorMsg = false;
    }
    this.getCity();
    this.setState((prevState) => {
      return { ...prevState, controls };
    });
    //this.props.updateState({ visibleArea: 'vehicleSelectCity', vehicleDetails: { controls, isValidForm } });
  }

  handleValidation = (isSubmit) => {
    let { controls, isValidForm } = this.state;
    let {
      subsidiaryName,
      gst,
      pan,
      address1,
      state,
      city,
      sap_id,
      pin_code,
    } = controls;

    // if (sap_id.touched === true) {
    //   sap_id = Validation.notNullValidator(sap_id);
    //   sap_id.valid = !sap_id.nullValue;
    //   if (sap_id.valid === false) {
    //     sap_id.showErrorMsg = true;
    //   } else {
    //     sap_id.showErrorMsg = false;
    //   }
    // }

    if (subsidiaryName.touched === true) {
      subsidiaryName = Validation.notNullValidator(subsidiaryName);
      subsidiaryName.valid = !subsidiaryName.nullValue;
      if (subsidiaryName.valid === false) {
        subsidiaryName.showErrorMsg = true;
      } else {
        subsidiaryName.showErrorMsg = false;
      }
    }

    if (gst.touched === true) {
      gst = Validation.validateLength(gst, 15);
      gst.valid = !gst.invalidLength;
      if (gst.valid === false) {
        gst.showErrorMsg = true;
      } else {
        gst.showErrorMsg = false;
      }
    }

    if (pan.touched === true) {
      pan = Validation.validateLength(pan, 10);
      pan.valid = !pan.invalidLength;
      if (pan.valid === false) {
        pan.showErrorMsg = true;
      } else {
        pan.showErrorMsg = false;
      }
    }

    if (address1.touched === true) {
      address1 = Validation.notNullValidator(address1);
      address1.valid = !address1.nullValue;
      if (address1.valid === false) {
        address1.showErrorMsg = true;
      } else {
        address1.showErrorMsg = false;
      }
    }

    // if (pin_code.touched === true) {
    //   pin_code = Validation.notNullValidator(pin_code);
    //   pin_code.valid = !pin_code.nullValue;
    //   if (pin_code.valid === false) {
    //     pin_code.showErrorMsg = true;
    //   } else {
    //     pin_code.showErrorMsg = false;
    //   }
    // }

    if (isSubmit) {
      sap_id = Validation.notNullValidator(sap_id);
      sap_id.showErrorMsg = sap_id.nullValue;

      subsidiaryName = Validation.notNullValidator(subsidiaryName);
      subsidiaryName.showErrorMsg = subsidiaryName.nullValue;

      address1 = Validation.notNullValidator(address1);
      address1.showErrorMsg = address1.nullValue;


      gst = Validation.validateLength(gst, 15);
      gst.showErrorMsg = gst.invalidLength;

      gst = Validation.notNullValidator(gst);
      gst.showErrorMsg = gst.nullValue;


      pan = Validation.validateLength(pan, 10);
      pan.showErrorMsg = pan.invalidLength;

      pan = Validation.notNullValidator(pan);
      pan.showErrorMsg = pan.nullValue;

      state = Validation.notNullValidator(state);
      state.showErrorMsg = state.nullValue;

      // pin_code = Validation.notNullValidator(pin_code);
      // pin_code.showErrorMsg = pin_code.nullValue;

      city = Validation.notNullValidator(city);
      city.showErrorMsg = city.nullValue;
      if (
        !subsidiaryName.showErrorMsg &&
        !address1.showErrorMsg &&
        !gst.showErrorMsg &&
        !state.showErrorMsg &&
        !city.showErrorMsg &&
        !pan.showErrorMsg &&
        !pin_code.showErrorMsg &&
        !sap_id.showErrorMsg
      ) {
        // if (this.state.from === "enroll-new-fleet") {
        //   // isValidForm = true;
        // } else {
        if (!sap_id.showErrorMsg && (sap_id.showErrorMsg !== 'true' || sap_id.showErrorMsg !== true)) {
          isValidForm = true;
        } else {
          isValidForm = false;
        }
        // }
      } else {
        isValidForm = false;
      }
    }
    this.setState((prevState) => {
      return { ...prevState, controls, isValidForm };
    });
  };

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    if (controlName === "pin_code") {
      if (!isNaN(controlValue)) {
        controls[controlName].value = controlValue;
        controls[controlName].touched = true;
      }
    } else {
      controls[controlName].value = controlValue;
      controls[controlName].touched = true;
    }
    this.setState({ controls });
    this.handleValidation(false);
  };

  handleAddress(textcontent, type) {
    let controlName = "address1";
    if (type === "address2") {
      controlName = "address2";
    }
    const controlValue = textcontent;
    const { controls } = this.state;
    controls[controlName].value = controlValue;
    controls[controlName].touched = true;
    this.setState({ controls });
    this.handleValidation(false);
  }

  addSubsidiaries() {
    this.handleValidation(true);
    const { controls } = this.state;
    let isValidForm = false;
    if (
      !controls.subsidiaryName.showErrorMsg &&
      !controls.address1.showErrorMsg &&
      !controls.gst.showErrorMsg &&
      !controls.state.showErrorMsg &&
      !controls.city.showErrorMsg &&
      !controls.pan.showErrorMsg &&
      !controls.pin_code.showErrorMsg
    ) {
      isValidForm = true;
    } else {
      return;
    }
    let objAddSubsidiaries = {
      subsidiary_name: controls.subsidiaryName.value,
      sap_id: controls.sap_id.value,
      address_1: controls.address1.value,
      address_2: controls.address2.value,
      gst_number: controls.gst.value,
      pan_number: controls.pan.value,
      city_id: controls.city.value.city_id,
      state_id: controls.state.value.state_id,
      pin_code: controls.pin_code.value,
    };
    if (this.props.from && this.props.from === "enroll-new-fleet") {
      objAddSubsidiaries.temp_id = this.props.temp_id;
      objAddSubsidiaries.from = "enroll-new-fleet";
    }
    if (controls.uuid) {
      objAddSubsidiaries.uuid = controls.uuid;
    }
    this.setState((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });

    objAddSubsidiaries.fleet_id = this.props.fleet_id;

    if (this.props.fleet_id) {
      AddEditSubsidiariesService.addEditSubsidiariesProfile(objAddSubsidiaries)
        .then((response) => {
          setTimeout(() => {
            this.setState((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
            swal("", response.data.message, "success").then((value) => {
              this.props.addSubsidiaries();
            });
          }, 500);
        })
        .catch((e) => {
          setTimeout(() => {
            if (
              e.response &&
              e.response.data &&
              e.response.data.error &&
              e.response.data.error.length > 0
            ) {
              swal("", e.response.data.error[0].message, "error");
            }
            this.setState((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          }, 500);
          console.error("e", e);
        });

    } else {

      AddEditSubsidiariesService.addEditSubsidiaries(objAddSubsidiaries)
        .then((response) => {
          setTimeout(() => {
            this.setState((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
            swal("", response.data.message, "success").then((value) => {
              this.props.addSubsidiaries();
            });
          }, 500);
        })
        .catch((e) => {
          setTimeout(() => {
            if (
              e.response &&
              e.response.data &&
              e.response.data.error &&
              e.response.data.error.length > 0
            ) {
              swal("", e.response.data.error[0].message, "error");
            }
            this.setState((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          }, 500);
          console.error("e", e);
        });
    }
    // if (!controls.subsidiaryName.showErrorMsg && !controls.address.showErrorMsg &&
    //   !controls.gst.showErrorMsg && !controls.state.showErrorMsg && !controls.city.showErrorMsg && !controls.pan.showErrorMsg) {
    //   isValidForm = true;
    // } else {
    //   isValidForm = false;
    // }
    // if (isValidForm) {
    // } else {

    // }
  }

  getStripedStyle(index) {
    return { background: index % 2 === 0 ? "#f6f6f6" : "white" };
  }

  render() {
    let {
      subsidiaryName,
      gst,
      pan,
      address1,
      address2,
      state,
      city,
      sap_id,
      pin_code,
    } = this.state.controls;
    let { controls, isDisplayDetail } = Object.assign({}, this.state);
    subsidiaryName = Object.assign({}, controls.subsidiaryName);
    let addEditSubsidiaries = this.props.addEditSubsidiaries;
    return (
      <div className="AddEdit-subsidiaries-wrapp">
        {this.state.isLoading && (
          <CustomSpinner marginTop="40%"></CustomSpinner>
        )}
        <Row style={{ marginLeft: "0", marginRight: "0" }}>
          <Col xl="6" md="12" xs="12">
            <FormGroup>
              <Label for="sap_id">SAP ID<span className="required-field">*</span></Label>
              <Input
                type="text"
                name="sap_id"
                disabled={isDisplayDetail}
                id="sap_id"
                value={sap_id.value}
                readOnly={this.state.isAddSubsidiaries ? false : true}
                onChange={this.handleInputChange}
                placeholder="Type here"
              />
              {sap_id.showErrorMsg && <div className="error">* {INVALID_SAP_ID}</div>}
            </FormGroup>
          </Col>
          <Col xl="6" md="12" xs="12">
            <FormGroup>
              <Label for="subsidiaryName">
                Subsidiary Name<span className="required-field">*</span>
              </Label>
              <Input
                type="text"
                name="subsidiaryName"
                id="subsidiaryName"
                disabled={isDisplayDetail}
                value={subsidiaryName.value}
                onChange={this.handleInputChange}
                placeholder="Type here"
              />
              {subsidiaryName.showErrorMsg && (
                <div className="error">* {INVALID_SUBSIDIARIES_NAME}</div>
              )}
            </FormGroup>
          </Col>

          <Col xl="6" md="12" xs="12">
            <FormGroup>
              <Label for="primaryPerson">
                Address 1<span className="required-field">*</span>
              </Label>
              <TextareaAutosize
                name="address"
                disabled={isDisplayDetail}
                id="address"
                value={address1.value}
                style={{ maxHeight: 100, fontSize: "14px" }}
                className="form-control"
                onChange={(e) => this.handleAddress(e.target.value, "address1")}
                placeholder="Type here"
              />
              {address1.showErrorMsg && (
                <div className="error">* {INVALID_ADDRESS}</div>
              )}
            </FormGroup>
          </Col>
          <Col xl="6" md="12" xs="12">
            <FormGroup>
              <Label for="primaryPerson">Address 2</Label>
              <TextareaAutosize
                name="address2"
                id="address2"
                disabled={isDisplayDetail}
                value={address2.value}
                style={{ maxHeight: 100, fontSize: "14px" }}
                className="form-control"
                onChange={(e) => this.handleAddress(e.target.value, "address2")}
                placeholder="Type here"
              />
            </FormGroup>
          </Col>
          <Col xl="6" md="12" xs="12">
            <FormGroup>
              <Label for="primaryPerson">
                State<span className="required-field">*</span>
              </Label>
              <div className="d-flex-row subsdiaries-typehead">
                <Typeahead
                  filterBy={(option, props) => {
                    if (props.selected.length) {
                      return true;
                    }
                    return (
                      option &&
                      option.name &&
                      (option.name
                        .toLowerCase()
                        .indexOf(props.text.toLowerCase()) !== -1 ||
                        option.name.toLowerCase().indexOf("other") !== -1)
                    );
                  }}
                  bsSize="small"
                  id="statetypehead"
                  labelKey="name"
                  disabled={isDisplayDetail}
                  options={this.stateData}
                  onChange={(selectedState) => {
                    this.stateClick(selectedState[0])
                    // Reset the selected city
                    this.cityClick(null);
                  }}
                  placeholder="Type here"
                  selected={this.selectedState ? [this.selectedState] : []}
                  ref={(typeahead) => (this.typeaheadState = typeahead)}
                />
              </div>
              {state.showErrorMsg && (
                <div className="error">* {INVALID_STATE}</div>
              )}
            </FormGroup>
          </Col>
          <Col xl="6" md="12" xs="12">
            <FormGroup>
              <Label for="primaryPerson">
                City<span className="required-field">*</span>
              </Label>
              <div className="d-flex-row subsdiaries-typehead">
                <Typeahead
                  filterBy={(option, props) => {
                    if (props.selected.length) {
                      return true;
                    }
                    return (
                      option.name
                        .toLowerCase()
                        .indexOf(props.text.toLowerCase()) !== -1 ||
                      option.name.toLowerCase().indexOf("other") !== -1
                    );
                  }}
                  bsSize="small"
                  id="citytypehead"
                  disabled={isDisplayDetail}
                  labelKey="name"
                  options={this.cityData}
                  onChange={(selectedCity) => this.cityClick(selectedCity[0])}
                  placeholder="Type here"
                  selected={this.selectedCity ? [this.selectedCity] : []}
                  ref={(typeahead) => (this.typeaheadCity = typeahead)}
                />
              </div>
              {city.showErrorMsg && (
                <div className="error">* {INVALID_CITY}</div>
              )}
            </FormGroup>
          </Col>
          <Col xl="6" md="12" xs="12">
            <FormGroup>
              <Label for="primaryPerson">
                Pincode
                {/* <span className="required-field">*</span> */}
              </Label>
              <Input
                type="text"
                name="pin_code"
                id="pan"
                disabled={isDisplayDetail}
                className="capital-case"
                maxLength="6"
                value={pin_code.value}
                onChange={this.handleInputChange}
                placeholder="Type here"
              />
              {pin_code.showErrorMsg && (
                <div className="error">*Please enter pincode</div>
              )}
              {/* <Input
                type="text"
                name="pan"
                id="pan"
                value={pan.value}
                onChange={this.handleInputChange}
                placeholder="Type here" />
              {pan.showErrorMsg && <div className="error">* {INVALID_PAN}</div>} */}
              {/* {primaryPerson.showErrorMsg && <div className="error">* {INVALID_PERSON_NAME}</div>} */}
            </FormGroup>
          </Col>
          <Col xl="6" md="12" xs="12">
            <FormGroup>
              <Label for="primaryPerson">PAN<span className="required-field">*</span></Label>
              <Input
                type="text"
                disabled={isDisplayDetail}
                name="pan"
                id="pan"
                className="capital-case"
                value={pan.value}
                onChange={this.handleInputChange}
                placeholder="Type here"
              />
              {pan.showErrorMsg && <div className="error">* {INVALID_PAN}</div>}
              {/* <Input
                type="text"
                name="pan"
                id="pan"
                value={pan.value}
                onChange={this.handleInputChange}
                placeholder="Type here" />
              {pan.showErrorMsg && <div className="error">* {INVALID_PAN}</div>} */}
              {/* {primaryPerson.showErrorMsg && <div className="error">* {INVALID_PERSON_NAME}</div>} */}
            </FormGroup>
          </Col>
          <Col xl="6" md="12" xs="12">
            <FormGroup>
              <Label for="primaryPerson">GSTIN<span className="required-field">*</span></Label>
              <Input
                type="text"
                name="gst"
                id="gst"
                className="capital-case"
                value={gst.value}
                disabled={isDisplayDetail}
                onChange={this.handleInputChange}
                placeholder="Type here"
              />
              {gst.showErrorMsg && <div className="error">* {INVALID_GST}</div>}
            </FormGroup>
          </Col>
        </Row>
        {/* <Row style={{ marginLeft: '0', marginRight: '0' }}>
          
        </Row>
        <Row style={{ marginLeft: '0', marginRight: '0' }}>
        
        </Row> */}
        {!isDisplayDetail && (
          <Col xl="12" xs="12" md="12" className="text-align-right mt-3">
            <Button
              className="mb-1 mr-1 btn-pill action-button profile-save-button"
              color="warning"
              onClick={() => {
                this.addSubsidiaries();
              }}
            >
              {this.state.isAddSubsidiaries ? "Add" : "Edit"}
            </Button>
          </Col>
        )}
        {addEditSubsidiaries.length > 1 && (
          <Col xl="12" md="12" xs="12">
            <Table className="mb-0 table-responsive mt-2 mb-2 tbl-subsidiaries">
              <thead>
                <tr style={{ ...this.getStripedStyle(0) }}>
                  <th>Sr. No</th>
                  <th>Subsidiary Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {addEditSubsidiaries.map(
                  (row, i) =>
                    row.controls.subsidiaryName.value && (
                      <tr key={i} style={{ ...this.getStripedStyle(i + 1) }}>
                        <td>{i + 1}</td>
                        <td>{row.controls.subsidiaryName.value}</td>
                        <td>
                          <img
                            className="cursor-pointer"
                            src="images/edit.svg"
                            alt="edit"
                            onClick={() => this.setEditData(i)}
                          />
                          &nbsp;&nbsp;
                          <img
                            className="cursor-pointer"
                            src="images/delete.svg"
                            alt="delete"
                            onClick={() =>
                              this.removeSubsidiaries(row.controls.uuid)
                            }
                          />
                        </td>
                      </tr>
                    )
                )}
              </tbody>
            </Table>
          </Col>
        )}
      </div>
    );
  }
}

export default AddEditSubsidiaries;
